var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amendments-filter filters-container"},[_c('select-filter',{attrs:{"type":"amendments","field":"status","label":"Статус","request":"objectInfo/contract_statuses","parse-value":({ name }) => name}}),_c('sorting-control',{staticStyle:{"margin-left":"32px"},attrs:{"type":"amendments","values":_vm.sortingFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }